import * as yup from '@if/core/yup'

export const EditProfileInformationSchema = yup.object({
  firstName: yup.text().validCharacters().max(50).required(),
  lastName: yup.text().validCharacters().max(50).required(),
  jobTitle: yup.text().max(100).required(),
  phone: yup.text(),
  language: yup.text().required().oneOf(['fr', 'en']),
})

export type EditProfileInformation = yup.InferSubmit<typeof EditProfileInformationSchema>
